import { ajax } from '../http.js'

export default {

    /**
     * 上传附件方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    uploadFile(searchParams, headers) {
        return ajax('common/upload', 'POST', searchParams, headers);
    },





}